import React from 'react';

import BankStatementCollection from './BankStatementCollection';

export default function BankStatementCollections({
  bankStatementCollections,
  refetch,
}) {
  return (
    <div className="pb-10">
      {bankStatementCollections?.map((collection, index) => {
        return (
          <BankStatementCollection
            key={collection.id}
            bankStatementCollection={collection}
            refetch={refetch}
            index={index}
          />
        );
      })}
    </div>
  );
}
